export const ADD_VARIABLE = "ADD_VARIABLE";
export const GET_VARIABLES = "GET_VARIABLES";
export const UPDATE_VARIABLE = "UPDATE_VARIABLE";
export const DELETE_VARIABLE = "DELETE_VARIABLE";
export const ADD_ERROR = "ADD_ERROR";
export const UPDATE_ERROR = "UPDATE_ERROR";
export const GET_ERROR = "GET_ERROR";
export const DELETE_ERROR = "DELETE_ERROR";
